.atm_9s_1txwivl{display:flex;}
.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_r3_1e5hqsa{text-align:left;}
.atm_c8_1cbyki6.atm_c8_1cbyki6{font-size:1.125rem;}
.atm_cs_1fw03zg.atm_cs_1fw03zg{font-weight:700;}
.atm_gq_idpfg4.atm_gq_idpfg4{margin-bottom:0;}
.atm_gq_1y44olf.atm_gq_1y44olf{margin-bottom:4px;}
.atm_gi_idpfg4{margin:0;}
.atm_j3_dgintm{max-width:500px;}
.atm_c8_1x7uoys.atm_c8_1x7uoys{font-size:0.875rem;}
.atm_7l_1ywnbtm{color:#8E959E;}
.atm_mk_h2mmj6{position:relative;}
.atm_vy_1osqo2v{width:100%;}
.atm_e2_1osqo2v{height:100%;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_73_usvi9m{box-sizing:border-box;}
.atm_6e_glywfm.atm_6e_glywfm{border-top-style:none;}
.atm_5t_glywfm.atm_5t_glywfm{border-right-style:none;}
.atm_5h_glywfm.atm_5h_glywfm{border-left-style:none;}
.atm_48_t94yts.atm_48_t94yts{border-bottom-width:1px;}
.atm_47_nqa18y.atm_47_nqa18y{border-bottom-style:solid;}
.atm_41_1j28jx2.atm_41_1j28jx2{border-bottom-color:transparent;}
.atm_2d_1x778eo.atm_2d_1x778eo{background-color:white;}
.atm_uc_niektb{transition:border-bottom-color 0.3s ease,background-color 0.3s ease;}
.atm_ar_vrvcex.atm_ar_vrvcex{flex-direction:row;}
.atm_ar_1sbvcyy.atm_ar_1sbvcyy{flex-direction:row-reverse;}
.atm_2d_118lp2q.atm_2d_118lp2q{background-color:#F4F5F7;}
.atm_47_glywfm.atm_47_glywfm{border-bottom-style:none;}
.atm_5j_s5gm8b{border-radius:8px 8px 0 0;}
.atm_6f_t94yts.atm_6f_t94yts{border-top-width:1px;}
.atm_6e_nqa18y.atm_6e_nqa18y{border-top-style:solid;}
.atm_68_j1e0tf.atm_68_j1e0tf{border-top-color:#CED3DA;}
.atm_5u_t94yts.atm_5u_t94yts{border-right-width:1px;}
.atm_5t_nqa18y.atm_5t_nqa18y{border-right-style:solid;}
.atm_5r_j1e0tf.atm_5r_j1e0tf{border-right-color:#CED3DA;}
.atm_5i_t94yts.atm_5i_t94yts{border-left-width:1px;}
.atm_5h_nqa18y.atm_5h_nqa18y{border-left-style:solid;}
.atm_5f_j1e0tf.atm_5f_j1e0tf{border-left-color:#CED3DA;}
.atm_2d_unflqz.atm_2d_unflqz{background-color:#9EC5FF;}
.atm_7l_1n93km5{color:#0045AD;}
.atm_tej1as_1n93km5 svg{color:#0045AD;}
.atm_2d_kynrkz.atm_2d_kynrkz{background-color:#FFF1D6;}
.atm_7l_1faz6al{color:#7A4900;}
.atm_tej1as_1faz6al svg{color:#7A4900;}
.atm_2d_cribmc.atm_2d_cribmc{background-color:#FFF1F0;}
.atm_68_118lp2q.atm_68_118lp2q{border-top-color:#F4F5F7;}
.atm_5r_118lp2q.atm_5r_118lp2q{border-right-color:#F4F5F7;}
.atm_5f_118lp2q.atm_5f_118lp2q{border-left-color:#F4F5F7;}
.atm_41_j1e0tf.atm_41_j1e0tf{border-bottom-color:#CED3DA;}
.atm_blassl_9ztun4 span{color:#DD3131;}
.atm_9j_n7od8j{cursor:unset;}
.atm_blassl_j1e0tf span{color:#CED3DA;}
.atm_lzn0r3_1yyfdc7::before{content:'';}
.atm_6hjprp_stnw88::before{position:absolute;}
.atm_va5d7e_glywfm::before{pointer-events:none;}
.atm_2stpi8_grho7r::before{top:0px;}
.atm_44hr8e_grho7r::before{left:0px;}
.atm_k1nb77_nb8q6m::before{border:2px solid #146EF5;}
.atm_jxpu17_ftgil2::before{border-radius:8px;}
.atm_1v8yup7_1osqo2v::before{width:100%;}
.atm_1oletfx_1osqo2v::before{height:100%;}
.atm_1hf877f_zo7u8::before{z-index:10;}
.atm_fqzfsq_idpfg4::before{opacity:0;}
.atm_3ieh09_htodee::before{transition:0.2s ease;}
.atm_17yrrpa_glywfm:focus-visible{outline:none;}
.atm_1ktgdtx_kb7nvz:focus-visible ::before{opacity:1;}
.atm_m_n7od8j{all:unset;}
.atm_am_kb7nvz{flex:1;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_l8_nuc8tx{padding:var(--accordion-header-padding, 16px);}
.atm_e2_1ylpe5n{height:40px;}
.atm_l8_ftgil2{padding:8px;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_3f_okh77k{border:1px solid transparent;}
.atm_tej1as_j1e0tf svg{color:#CED3DA;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_h0_ftgil2.atm_h0_ftgil2{margin-right:8px;}
.atm_uc_nyl60a{transition:transform 300ms ease-out;}
.atm_ar_1h6ojuz.atm_ar_1h6ojuz{flex-direction:center;}
.atm_tr_1ul7t97{transform:rotate(0deg);}
.atm_tr_1sub3qo{transform:rotate(180deg);}
.atm_cx_ftgil2{gap:8px;}
.atm_bb_idpfg4.atm_bb_idpfg4{flex-shrink:0;}
.atm_7l_1kw7nm4{color:inherit;}
.atm_5j_ftgil2{border-radius:8px;}
.atm_3f_148wyss{border:1px solid #DD3131;}
.atm_3f_1fz0aif{border:1px solid #CED3DA;}
.atm_afzqfr_nrqlei:first-child{border-radius:8px 8px 0px 0px;}
.atm_1ovk6ut_glywfm:first-child{border-bottom:none;}
.atm_eoxiwz_1ahfofk:last-child{border-radius:0px 0px 8px 8px;}
.atm_1j73bul_glywfm:last-child{border-top:none;}
.atm_40_1fz0aif{border-bottom:1px solid #CED3DA;}
.atm_18kh1rq_glywfm:last-child{border-bottom:none;}
.atm_70_1oy2gec{box-shadow:0px 1px 1px 0px rgba(0, 33, 82, 0.15),0px 1px 3px 1px rgba(0, 33, 82, 0.15);}
.atm_5j_egc4ed{border-radius:0 0 8px 8px;}
.atm_5q_1fz0aif{border-right:1px solid #CED3DA;}
.atm_5e_1fz0aif{border-left:1px solid #CED3DA;}
.atm_67_glywfm{border-top:none;}
.atm_26_1x778eo{background:white;}
.atm_l8_exct8b{padding:16px;}
